export enum DisplayMode {
  Evse = 'EVSE',
  ChargePoint = 'CHARGE_POINT',
  Search = 'SEARCH',
}
